// products-data.js
export const productsData = {
  "fresh-produce": {
    name: "Fresh Produce",
    description: "Premium fruits and vegetables from Kenya's fertile highlands",
    products: [
      {
        id: 1,
        name: "Avocados (Hass & Fuerte)",
        description:
          "Premium export-quality avocados with perfect ripeness and flavor.",
        detailedDescription:
          "Our Hass and Fuerte avocados are carefully selected from the fertile highlands of Kenya, where ideal growing conditions produce fruits with exceptional taste and texture. Grown using sustainable farming practices, each avocado is hand-picked at peak maturity to ensure optimal flavor development and nutritional value.",
        image: "../../../assets/images/products/avocado-prd.png",
        category: "fruits",
        subcategory: "fruits",
        specifications: {
          origin: "Kenyan Highlands",
          variety: "Hass & Fuerte",
          size: "Medium to Large",
          packaging: "4kg cartons, 10kg boxes",
          shelfLife: "2-3 weeks at optimal conditions",
          certifications: ["GlobalG.A.P.", "Organic Certified", "HACCP"],
        },
        nutritionalInfo: {
          calories: "160 kcal",
          fat: "15g",
          carbohydrates: "9g",
          protein: "2g",
          vitamins: "Rich in Vitamin K, C, E, and B-6",
        },
        seasonality: "Year-round with peak season March-June",
        minOrder: "100kg",
        priceRange: "$15-25 per kg (depending on season and quantity)",
        shippingInfo: "Air freight (3-5 days), Refrigerated containers",
      },
      {
        id: 2,
        name: "Mangoes (Kent & Apple)",
        description:
          "Sweet, juicy mangoes harvested at peak season for optimal taste.",
        detailedDescription:
          "Our Kenyan mangoes are renowned for their exceptional sweetness and rich flavor profile. The Kent variety offers a sweet, rich flavor with minimal fiber, while the Apple mango is particularly juicy with a distinctive aromatic flavor. Grown in the sun-drenched orchards of Eastern Kenya, these mangoes are harvested at the perfect stage of ripeness.",
        image: "../../../assets/images/products/mangoes-prd.png",
        category: "fruits",
        subcategory: "fruits",
        specifications: {
          origin: "Eastern Kenya",
          variety: "Kent & Apple",
          size: "Medium to Large (300-500g)",
          packaging: "4kg cartons, 10kg boxes",
          shelfLife: "2-3 weeks at 10-13°C",
          certifications: ["GlobalG.A.P.", "HACCP", "KEPHIS Certified"],
        },
        nutritionalInfo: {
          calories: "99 kcal",
          fat: "0.6g",
          carbohydrates: "25g",
          protein: "1.4g",
          vitamins: "Excellent source of Vitamins A and C",
        },
        seasonality: "October to March",
        minOrder: "200kg",
        priceRange: "$12-20 per kg (seasonal)",
        shippingInfo: "Air freight (3-5 days), Controlled atmosphere",
      },
      {
        id: 3,
        name: "French Beans",
        description:
          "Tender, crisp French beans grown in the highlands of Kenya.",
        detailedDescription:
          "Our French beans are cultivated in the fertile highlands of Kenya, where the ideal climate and soil conditions produce beans with exceptional crispness and sweet flavor. Carefully hand-picked at the perfect stage of maturity, these beans maintain their freshness and nutritional value from farm to table.",
        image: "../../../assets/images/products/french-beans-prd.png",
        category: "vegetables",
        subcategory: "vegetables",
        specifications: {
          origin: "Kenyan Highlands",
          variety: "Fine Beans",
          size: "Extra Fine (4-6mm diameter)",
          packaging: "5kg cartons, 10kg boxes",
          shelfLife: "10-14 days at 4-7°C",
          certifications: ["GlobalG.A.P.", "HACCP", "KEPHIS Certified"],
        },
        nutritionalInfo: {
          calories: "31 kcal",
          fat: "0.2g",
          carbohydrates: "7g",
          protein: "1.8g",
          vitamins: "Rich in Vitamin C, K, and Folate",
        },
        seasonality: "Year-round with peak season June-September",
        minOrder: "100kg",
        priceRange: "$8-15 per kg (depending on season)",
        shippingInfo: "Air freight (3-5 days), Refrigerated containers",
      },
      {
        id: 4,
        name: "Snow Peas",
        description:
          "Sweet and crunchy snow peas, carefully selected for export.",
        detailedDescription:
          "Our snow peas are grown in the cool highlands of Kenya, where they develop their characteristic sweet flavor and crisp texture. Harvested at the perfect stage of maturity, these peas are tender yet crunchy, making them perfect for stir-fries, salads, and various culinary applications.",
        image: "../../../assets/images/products/snow-peas-prd.JPG",
        category: "vegetables",
        subcategory: "vegetables",
        specifications: {
          origin: "Central Kenya Highlands",
          variety: "Oregon Sugar Pod",
          size: "Medium to Large (7-9cm length)",
          packaging: "4kg cartons, 8kg boxes",
          shelfLife: "10-12 days at 2-4°C",
          certifications: ["GlobalG.A.P.", "HACCP", "Organic Certified"],
        },
        nutritionalInfo: {
          calories: "42 kcal",
          fat: "0.2g",
          carbohydrates: "7.5g",
          protein: "2.8g",
          vitamins: "Excellent source of Vitamin C and K",
        },
        seasonality: "Year-round with best quality October-February",
        minOrder: "80kg",
        priceRange: "$10-18 per kg",
        shippingInfo: "Air freight (3-5 days), Refrigerated containers",
      },
      {
        id: 13,
        name: "Kale",
        description: "Fresh, nutrient-rich kale from organic farms.",
        detailedDescription:
          "Our organic kale is grown in the rich volcanic soils of Kenya's highlands, where it develops its deep green color and robust flavor. Packed with nutrients and antioxidants, this kale is harvested at peak freshness to ensure maximum nutritional value and flavor.",
        image: "../../../assets/images/products/kale-prd.png",
        category: "vegetables",
        subcategory: "vegetables",
        specifications: {
          origin: "Central Kenya Highlands",
          variety: "Curly Kale",
          size: "Bunched, Medium leaves",
          packaging: "5kg cartons, 10kg boxes",
          shelfLife: "7-10 days at 0-2°C",
          certifications: ["Organic Certified", "GlobalG.A.P.", "HACCP"],
        },
        nutritionalInfo: {
          calories: "49 kcal",
          fat: "0.9g",
          carbohydrates: "8.8g",
          protein: "4.3g",
          vitamins: "Excellent source of Vitamins A, C, and K",
        },
        seasonality: "Year-round",
        minOrder: "50kg",
        priceRange: "$6-12 per kg",
        shippingInfo: "Air freight (3-5 days), Refrigerated containers",
      },
      {
        id: 14,
        name: "Spinach",
        description: "Tender spinach leaves, perfect for salads and cooking.",
        detailedDescription:
          "Our fresh spinach is grown in the fertile soils of Kenya's agricultural regions, where it develops its tender leaves and mild, sweet flavor. Carefully harvested and packed to preserve its freshness and nutritional value, this spinach is perfect for both raw consumption and cooking.",
        image: "../../../assets/images/products/spinach-prd.jpg",
        category: "vegetables",
        subcategory: "vegetables",
        specifications: {
          origin: "Various regions of Kenya",
          variety: "Flat Leaf Spinach",
          size: "Baby to Medium leaves",
          packaging: "2kg bags, 5kg cartons",
          shelfLife: "7-10 days at 0-2°C",
          certifications: ["GlobalG.A.P.", "HACCP", "KEPHIS Certified"],
        },
        nutritionalInfo: {
          calories: "23 kcal",
          fat: "0.4g",
          carbohydrates: "3.6g",
          protein: "2.9g",
          vitamins: "Rich in Iron, Vitamin A, and Folate",
        },
        seasonality: "Year-round",
        minOrder: "60kg",
        priceRange: "$7-14 per kg",
        shippingInfo: "Air freight (3-5 days), Refrigerated containers",
      },
      {
        id: 15,
        name: "Broccoli",
        description:
          "Fresh broccoli with tight florets and vibrant green color.",
        detailedDescription:
          "Our broccoli is grown in the cool highlands of Kenya, where ideal growing conditions produce heads with tight, compact florets and rich green color. Harvested at peak maturity, this broccoli offers excellent flavor, texture, and nutritional value, making it a premium choice for export markets.",
        image: "../../../assets/images/products/broccoli-prd.png",
        category: "vegetables",
        subcategory: "vegetables",
        specifications: {
          origin: "Kenyan Highlands",
          variety: "Calabrese",
          size: "Medium heads (15-18cm diameter)",
          packaging: "10kg cartons, 20kg boxes",
          shelfLife: "10-14 days at 0-2°C",
          certifications: ["GlobalG.A.P.", "HACCP", "KEPHIS Certified"],
        },
        nutritionalInfo: {
          calories: "34 kcal",
          fat: "0.4g",
          carbohydrates: "7g",
          protein: "2.8g",
          vitamins: "Excellent source of Vitamin C, K, and Folate",
        },
        seasonality: "Year-round with peak season June-September",
        minOrder: "80kg",
        priceRange: "$8-16 per kg",
        shippingInfo: "Air freight (3-5 days), Refrigerated containers",
      },
      {
        id: 16,
        name: "Pineapples",
        description: "Sweet, golden pineapples with perfect sugar content.",
        detailedDescription:
          "Our Kenyan pineapples are grown in the tropical regions of the country, where they develop their characteristic golden flesh and perfect balance of sweetness and acidity. Harvested at peak ripeness, these pineapples offer exceptional flavor and aroma that embodies the taste of tropical sunshine.",
        image: "../../../assets/images/products/pineapple-prd.jpg",
        category: "fruits",
        subcategory: "fruits",
        specifications: {
          origin: "Coastal Kenya",
          variety: "Smooth Cayenne",
          size: "1.5-2.5kg each",
          packaging: "10kg cartons, individual fruit wrapping",
          shelfLife: "2-3 weeks at 7-10°C",
          certifications: ["GlobalG.A.P.", "HACCP", "KEPHIS Certified"],
        },
        nutritionalInfo: {
          calories: "50 kcal",
          fat: "0.1g",
          carbohydrates: "13g",
          protein: "0.5g",
          vitamins: "Excellent source of Vitamin C and Manganese",
        },
        seasonality: "Year-round with peak season December-March",
        minOrder: "100kg",
        priceRange: "$10-20 per kg",
        shippingInfo: "Sea freight (4-6 weeks), Air freight (3-5 days)",
      },
      {
        id: 17,
        name: "Passion Fruit",
        description: "Aromatic passion fruit with intense flavor.",
        detailedDescription:
          "Our passion fruits are grown in the ideal climate of Kenya's highlands, where they develop their intense aromatic flavor and perfect balance of sweetness and acidity. These fruits are harvested at the perfect stage of ripeness, ensuring they arrive with their characteristic wrinkled skin and bursting with flavor.",
        image: "../../../assets/images/products/passion-fruit-prd.png",
        category: "fruits",
        subcategory: "fruits",
        specifications: {
          origin: "Central Kenya Highlands",
          variety: "Purple Passion Fruit",
          size: "Medium (4-6cm diameter)",
          packaging: "5kg cartons, 10kg boxes",
          shelfLife: "2-3 weeks at 5-7°C",
          certifications: ["GlobalG.A.P.", "HACCP", "KEPHIS Certified"],
        },
        nutritionalInfo: {
          calories: "97 kcal",
          fat: "0.7g",
          carbohydrates: "23g",
          protein: "2.2g",
          vitamins: "Rich in Vitamin C, A, and dietary fiber",
        },
        seasonality: "Year-round with peak season January-April",
        minOrder: "50kg",
        priceRange: "$12-22 per kg",
        shippingInfo: "Air freight (3-5 days), Controlled atmosphere",
      },
      {
        id: 18,
        name: "Basil",
        description: "Fresh aromatic basil for culinary use.",
        detailedDescription:
          "Our fresh basil is grown in the fertile soils of Kenya, where it develops its characteristic aromatic oils and vibrant green leaves. Carefully harvested and packed to preserve its freshness and flavor, this basil is perfect for pesto, salads, and various culinary applications that require the authentic taste of fresh herbs.",
        image: "../../../assets/images/products/basil-prd.png",
        category: "herbs",
        subcategory: "herbs",
        specifications: {
          origin: "Various regions of Kenya",
          variety: "Sweet Basil",
          size: "Bunched fresh leaves",
          packaging: "1kg boxes, 5kg cartons",
          shelfLife: "7-10 days at 2-4°C",
          certifications: ["GlobalG.A.P.", "HACCP", "Organic Certified"],
        },
        nutritionalInfo: {
          calories: "22 kcal",
          fat: "0.6g",
          carbohydrates: "2.7g",
          protein: "3.2g",
          vitamins: "Rich in Vitamin K, A, and antioxidants",
        },
        seasonality: "Year-round",
        minOrder: "20kg",
        priceRange: "$15-25 per kg",
        shippingInfo: "Air freight (3-5 days), Refrigerated containers",
      },
      {
        id: 19,
        name: "Coriander (Cilantro)",
        description: "Fresh cilantro with vibrant flavor.",
        detailedDescription:
          "Our fresh coriander (cilantro) is grown in Kenya's ideal growing conditions, where it develops its characteristic vibrant flavor and aroma. Carefully harvested and packed to maintain its freshness, this herb is perfect for adding authentic flavor to a wide range of culinary dishes from various cuisines.",
        image: "../../../assets/images/products/cilantro-prd.jpg",
        category: "herbs",
        subcategory: "herbs",
        specifications: {
          origin: "Various regions of Kenya",
          variety: "Coriander Leaf",
          size: "Bunched fresh leaves",
          packaging: "1kg boxes, 5kg cartons",
          shelfLife: "7-10 days at 2-4°C",
          certifications: ["GlobalG.A.P.", "HACCP", "KEPHIS Certified"],
        },
        nutritionalInfo: {
          calories: "23 kcal",
          fat: "0.5g",
          carbohydrates: "3.7g",
          protein: "2.1g",
          vitamins: "Rich in Vitamin K, A, and antioxidants",
        },
        seasonality: "Year-round",
        minOrder: "20kg",
        priceRange: "$12-20 per kg",
        shippingInfo: "Air freight (3-5 days), Refrigerated containers",
      },
      {
        id: 20,
        name: "Rosemary",
        description: "Aromatic rosemary for cooking and garnishing.",
        detailedDescription:
          "Our fresh rosemary is grown in the sunny climates of Kenya, where it develops its characteristic strong aromatic oils and needle-like leaves. This versatile herb is perfect for seasoning meats, vegetables, and various dishes, adding its distinctive pine-like flavor and aroma to culinary creations.",
        image: "../../../assets/images/products/rosemary-prd.png",
        category: "herbs",
        subcategory: "herbs",
        specifications: {
          origin: "Various regions of Kenya",
          variety: "Tuscan Blue Rosemary",
          size: "Bunched fresh sprigs",
          packaging: "1kg boxes, 5kg cartons",
          shelfLife: "10-14 days at 2-4°C",
          certifications: ["GlobalG.A.P.", "HACCP", "Organic Certified"],
        },
        nutritionalInfo: {
          calories: "131 kcal",
          fat: "5.9g",
          carbohydrates: "20.7g",
          protein: "3.3g",
          vitamins: "Rich in Iron, Calcium, and Vitamin B6",
        },
        seasonality: "Year-round",
        minOrder: "15kg",
        priceRange: "$18-30 per kg",
        shippingInfo: "Air freight (3-5 days), Refrigerated containers",
      },
    ],
  },
  tea: {
    name: "Tea",
    description:
      "World-renowned tea leaves from Kenya's high-altitude plantations",
    products: [
      {
        id: 5,
        name: "Black CTC Tea",
        description:
          "Rich, full-bodied black tea with robust flavor and aroma.",
        detailedDescription:
          "Our Black CTC (Crush, Tear, Curl) tea is produced from carefully selected tea leaves grown in the high-altitude regions of Kenya. The unique processing method gives this tea its characteristic strong flavor, bright color, and quick brewing properties. Perfect for those who enjoy a robust, invigorating cup of tea.",
        image: "../../../assets/images/products/black-tea-prd.JPG",
        category: "black-tea",
        subcategory: "black-tea",
        specifications: {
          origin: "Kericho Highlands",
          type: "CTC Black Tea",
          grade: "BP1 (Broken Pekoe 1)",
          packaging: "25kg paper sacks, 5kg foil bags",
          shelfLife: "24 months in proper storage",
          certifications: [
            "KTDA Certified",
            "ISO 22000",
            "Rainforest Alliance",
          ],
        },
        brewingGuide: {
          temperature: "100°C (boiling water)",
          quantity: "1 teaspoon per cup",
          steepingTime: "3-5 minutes",
          suggestions: "Excellent with milk and sugar",
        },
        seasonality: "Year-round with peak quality January-March",
        minOrder: "50kg",
        priceRange: "$8-15 per kg (depending on grade)",
        shippingInfo: "Sea freight (4-6 weeks), Air freight (3-5 days)",
      },
      {
        id: 6,
        name: "Purple Tea",
        description: "Antioxidant-rich purple tea, a unique Kenyan specialty.",
        detailedDescription:
          "Our Purple Tea is a unique Kenyan specialty known for its distinctive purple leaves and high antioxidant content. This tea offers a smooth, mild flavor with subtle fruity notes and is rich in anthocyanins, the same antioxidants found in blueberries and purple grapes. A truly exceptional and healthy tea experience.",
        image: "../../../assets/images/products/purple-tea-prd.JPEG",
        category: "black-tea",
        subcategory: "black-tea",
        specifications: {
          origin: "Nandi Hills, Kenya",
          type: "Orthodox Purple Tea",
          grade: "OP (Orange Pekoe)",
          packaging: "25kg paper sacks, 5kg foil bags",
          shelfLife: "24 months in proper storage",
          certifications: [
            "KTDA Certified",
            "ISO 22000",
            "Rainforest Alliance",
          ],
        },
        brewingGuide: {
          temperature: "95°C",
          quantity: "1 teaspoon per cup",
          steepingTime: "3-4 minutes",
          suggestions:
            "Best enjoyed without milk to appreciate its unique flavor",
        },
        seasonality: "Year-round with peak quality February-April",
        minOrder: "30kg",
        priceRange: "$15-25 per kg",
        shippingInfo: "Sea freight (4-6 weeks), Air freight (3-5 days)",
      },
      {
        id: 7,
        name: "Green Tea",
        description:
          "Delicate green tea with fresh, vegetal notes and health benefits.",
        detailedDescription:
          "Our Green Tea is carefully processed to preserve its natural antioxidants and fresh flavor. Grown in the high-altitude regions of Kenya, this tea offers a delicate, vegetal taste with subtle sweet notes. Rich in catechins and other antioxidants, it's not only delicious but also offers numerous health benefits.",
        image: "../../../assets/images/products/green-tea-prd.png",
        category: "green-tea",
        subcategory: "green-tea",
        specifications: {
          origin: "Kericho Highlands",
          type: "Green Tea",
          grade: "Pekoe",
          packaging: "25kg paper sacks, 5kg foil bags",
          shelfLife: "18 months in proper storage",
          certifications: [
            "KTDA Certified",
            "ISO 22000",
            "Rainforest Alliance",
          ],
        },
        brewingGuide: {
          temperature: "80-85°C",
          quantity: "1 teaspoon per cup",
          steepingTime: "2-3 minutes",
          suggestions: "Best enjoyed plain to appreciate its delicate flavor",
        },
        seasonality: "Year-round with peak quality March-May",
        minOrder: "40kg",
        priceRange: "$12-20 per kg",
        shippingInfo: "Sea freight (4-6 weeks), Air freight (3-5 days)",
      },
      {
        id: 8,
        name: "Herbal Tea Blends",
        description: "Custom herbal tea blends featuring Kenyan ingredients.",
        detailedDescription:
          "Our Herbal Tea Blends combine the finest Kenyan tea with locally sourced herbs, flowers, and spices to create unique and flavorful infusions. From calming chamomile blends to invigorating ginger-infused teas, each blend is carefully crafted to offer a distinctive taste experience and health benefits.",
        image: "../../../assets/images/products/herbal-tea-prd.JPG",
        category: "herbal-tea",
        subcategory: "herbal-tea",
        specifications: {
          origin: "Various regions of Kenya",
          type: "Herbal Infusion Blends",
          packaging: "25kg paper sacks, 5kg foil bags, tea bags",
          shelfLife: "18 months in proper storage",
          certifications: ["KTDA Certified", "ISO 22000", "HACCP"],
        },
        brewingGuide: {
          temperature: "100°C (boiling water)",
          quantity: "1 teaspoon per cup or 1 tea bag",
          steepingTime: "5-7 minutes",
          suggestions: "Can be enjoyed hot or as iced tea",
        },
        seasonality: "Year-round",
        minOrder: "25kg",
        priceRange: "$15-30 per kg (depending on blend)",
        shippingInfo: "Sea freight (4-6 weeks), Air freight (3-5 days)",
      },
    ],
  },
  coffee: {
    name: "Coffee",
    description: "Premium Arabica coffee beans from the slopes of Mount Kenya",
    products: [
      {
        id: 9,
        name: "AA Grade Coffee",
        description:
          "The largest bean size with exceptional flavor complexity.",
        detailedDescription:
          "AA Grade represents the largest bean size in Kenyan coffee classification, known for its consistent size and superior quality. Grown on the fertile slopes of Mount Kenya at altitudes between 1,400-2,000 meters, these beans develop slowly, allowing complex flavors to mature. Our AA Grade coffee boasts a bright acidity, full body, and winey flavor with notes of berry and citrus.",
        image: "../../../assets/images/products/aa-coffee.prd.png",
        category: "premium",
        subcategory: "premium",
        specifications: {
          origin: "Mount Kenya Region",
          type: "Arabica",
          grade: "AA (Screen size 18-20)",
          process: "Fully washed",
          packaging: "60kg jute bags, vacuum packs",
          shelfLife: "24 months in proper storage",
          certifications: ["UTZ Certified", "Fair Trade", "Organic"],
        },
        flavorProfile: {
          acidity: "Bright",
          body: "Full",
          aroma: "Complex with berry notes",
          tastingNotes: "Blackcurrant, citrus, winey",
        },
        roastingGuide: {
          recommended: "Medium to Medium-Dark roast",
          characteristics:
            "Brings out the winey characteristics and bright acidity",
        },
        seasonality: "Main crop: October-December, Fly crop: April-June",
        minOrder: "30kg",
        priceRange: "$18-30 per kg (depending on market)",
        shippingInfo: "Sea freight (4-6 weeks), Vacuum-packed for freshness",
      },
      {
        id: 10,
        name: "AB Grade Coffee",
        description: "Medium bean size with balanced acidity and body.",
        detailedDescription:
          "AB Grade coffee offers excellent quality with slightly smaller beans than AA grade but maintaining the characteristic Kenyan coffee profile. Grown in the same ideal conditions as our premium grades, this coffee delivers a well-balanced cup with good acidity, medium body, and the distinctive Kenyan flavor that coffee enthusiasts appreciate.",
        image: "../../../assets/images/products/ab-coffee-prd.png",
        category: "arabica",
        subcategory: "arabica",
        specifications: {
          origin: "Mount Kenya Region",
          type: "Arabica",
          grade: "AB (Screen size 15-16)",
          process: "Fully washed",
          packaging: "60kg jute bags, vacuum packs",
          shelfLife: "24 months in proper storage",
          certifications: ["UTZ Certified", "Fair Trade", "Organic"],
        },
        flavorProfile: {
          acidity: "Medium",
          body: "Medium",
          aroma: "Fruity with nutty notes",
          tastingNotes: "Berry, chocolate, citrus",
        },
        roastingGuide: {
          recommended: "Medium roast",
          characteristics: "Highlights the balanced acidity and fruity notes",
        },
        seasonality: "Main crop: October-December, Fly crop: April-June",
        minOrder: "25kg",
        priceRange: "$15-25 per kg",
        shippingInfo: "Sea freight (4-6 weeks), Vacuum-packed for freshness",
      },
      {
        id: 11,
        name: "PB Grade Coffee",
        description: "Peaberry beans with concentrated flavor and sweetness.",
        detailedDescription:
          "PB (Peaberry) Grade consists of the small, round beans that occur when only one seed develops inside the coffee cherry instead of the usual two. These beans are known for their concentrated flavor and sweetness. Our Kenyan Peaberry coffee offers a bright acidity, full body, and complex flavor profile that is highly sought after by coffee connoisseurs.",
        image: "../../../assets/images/products/pb-coffee-prd.png",
        category: "specialty",
        subcategory: "specialty",
        specifications: {
          origin: "Mount Kenya Region",
          type: "Arabica",
          grade: "PB (Peaberry)",
          process: "Fully washed",
          packaging: "60kg jute bags, vacuum packs",
          shelfLife: "24 months in proper storage",
          certifications: ["UTZ Certified", "Fair Trade", "Organic"],
        },
        flavorProfile: {
          acidity: "Bright",
          body: "Full",
          aroma: "Complex with floral notes",
          tastingNotes: "Berry, citrus, honey",
        },
        roastingGuide: {
          recommended: "Light to Medium roast",
          characteristics: "Preserves the delicate floral notes and brightness",
        },
        seasonality: "Main crop: October-December, Fly crop: April-June",
        minOrder: "20kg",
        priceRange: "$20-35 per kg",
        shippingInfo: "Sea freight (4-6 weeks), Vacuum-packed for freshness",
      },
      {
        id: 12,
        name: "Specialty Blends",
        description: "Custom coffee blends for discerning clients worldwide.",
        detailedDescription:
          "Our Specialty Blends are carefully crafted combinations of different Kenyan coffee grades and regions to create unique flavor profiles tailored to specific market preferences. Whether you're looking for a balanced espresso blend, a bright filter coffee, or a distinctive single-origin profile, we can create custom blends that meet your exact specifications.",
        image: "../../../assets/images/products/coffee-specialty-blend-prd.png",
        category: "specialty",
        subcategory: "specialty",
        specifications: {
          origin: "Various Kenyan regions",
          type: "Arabica Blends",
          packaging: "60kg jute bags, vacuum packs",
          shelfLife: "24 months in proper storage",
          certifications: ["UTZ Certified", "Fair Trade", "Organic"],
        },
        flavorProfile: {
          acidity: "Customizable",
          body: "Customizable",
          aroma: "Customizable",
          tastingNotes: "Tailored to client specifications",
        },
        roastingGuide: {
          recommended: "Custom recommendations provided",
          characteristics: "Varies by blend composition",
        },
        seasonality: "Year-round availability",
        minOrder: "50kg",
        priceRange: "$15-30 per kg (depending on blend composition)",
        shippingInfo: "Sea freight (4-6 weeks), Vacuum-packed for freshness",
      },
    ],
  },
  "nuts-others": {
    name: "Nuts & Others",
    description: "Premium quality nuts and other specialty products from Kenya",
    products: [
      {
        id: 21,
        name: "Macadamia Nuts",
        description: "Premium grade macadamia nuts with rich, buttery flavor.",
        detailedDescription:
          "Our Kenyan macadamia nuts are grown in the fertile highlands where ideal climate conditions produce nuts with exceptional flavor and texture. Carefully harvested and processed to maintain their natural goodness, these nuts are known for their rich, buttery taste and crunchy texture. They are a perfect snack and versatile ingredient for both sweet and savory dishes.",
        image: "../../../assets/images/products/macadamia-prd.jpg",
        category: "nuts",
        subcategory: "macadamia",
        specifications: {
          origin: "Central Kenya Highlands",
          variety: "Hybrid Macadamia",
          size: "Extra Large (Jumbo Grade)",
          packaging: "10kg vacuum bags, 25kg cartons",
          shelfLife: "12 months in cool, dry conditions",
          certifications: ["GlobalG.A.P.", "Organic Certified", "HACCP"],
        },
        nutritionalInfo: {
          calories: "718 kcal",
          fat: "76g",
          carbohydrates: "14g",
          protein: "8g",
          vitamins: "Rich in Vitamin B1, Magnesium, and Manganese",
        },
        seasonality: "Year-round with main harvest March-September",
        minOrder: "50kg",
        priceRange: "$20-35 per kg (depending on grade and packaging)",
        shippingInfo: "Sea freight (4-6 weeks), Air freight (3-5 days)",
      },
      {
        id: 22,
        name: "Cashew Nuts",
        description: "Premium quality cashew nuts with delicate, sweet flavor.",
        detailedDescription:
          "Our Kenyan cashew nuts are cultivated in the coastal regions where the tropical climate provides perfect growing conditions. These premium nuts are carefully processed to preserve their natural flavor and nutritional value. Known for their delicate, sweet taste and creamy texture, they are excellent for snacking, cooking, and as ingredients in various culinary applications.",
        image: "../../../assets/images/products/cashew-prd.png",
        category: "nuts",
        subcategory: "cashewnuts",
        specifications: {
          origin: "Coastal Kenya",
          variety: "W180 (Large White)",
          size: "Large Whole Kernels",
          packaging: "10kg vacuum packs, 25kg cartons",
          shelfLife: "12 months in proper storage",
          certifications: ["GlobalG.A.P.", "HACCP", "KEPHIS Certified"],
        },
        nutritionalInfo: {
          calories: "553 kcal",
          fat: "44g",
          carbohydrates: "30g",
          protein: "18g",
          vitamins: "Rich in Copper, Magnesium, and Phosphorus",
        },
        seasonality: "Main harvest season January-March",
        minOrder: "50kg",
        priceRange: "$15-28 per kg (depending on grade)",
        shippingInfo: "Sea freight (4-6 weeks), Vacuum-packed for freshness",
      },
    ],
  },
};

// Helper function to get all products
export const getAllProducts = () => {
  const allProducts = [];
  Object.keys(productsData).forEach((category) => {
    productsData[category].products.forEach((product) => {
      allProducts.push({ ...product, mainCategory: category });
    });
  });
  return allProducts;
};

// Helper function to get product by ID
export const getProductById = (id) => {
  const allProducts = getAllProducts();
  return allProducts.find((product) => product.id === parseInt(id));
};

// Helper function to get related products
export const getRelatedProducts = (currentProduct, limit = 4) => {
  const allProducts = getAllProducts();
  return allProducts
    .filter(
      (product) =>
        product.id !== currentProduct.id &&
        (product.mainCategory === currentProduct.mainCategory ||
          product.category === currentProduct.category)
    )
    .slice(0, limit);
};
